import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from './Button';

const HeroWrapper = styled.section`
  position: relative;
  height: 60vh;
  width: 100%;
  overflow: hidden;
  background: linear-gradient(to right, rgba(0, 82, 156, 0.7), rgba(40, 126, 60, 0.7)), 
              url('https://images.unsplash.com/photo-1593113616828-6f22bca04804?ixlib=rb-1.2.1&auto=format&fit=crop&q=80');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 10vh;
    background: linear-gradient(to top, ${props => props.theme.colors.light}, transparent);
  }
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    height: 50vh;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 ${props => props.theme.spacing.xxl};
  max-width: 800px;
  margin: 0 auto;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 0 ${props => props.theme.spacing.xl};
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    padding: 0 ${props => props.theme.spacing.lg};
  }
`;

const HeroTitle = styled.h1`
  color: ${props => props.theme.colors.light};
  font-size: 3.5rem;
  margin-bottom: ${props => props.theme.spacing.md};
  line-height: 1.1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    font-size: 2.8rem;
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: 2.2rem;
  }
`;

const HeroSubtitle = styled.h2`
  color: ${props => props.theme.colors.light};
  font-size: 1.5rem;
  font-weight: ${props => props.theme.fontWeights.medium};
  margin-bottom: ${props => props.theme.spacing.xl};
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    font-size: 1.3rem;
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: 1.1rem;
    margin-bottom: ${props => props.theme.spacing.lg};
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.md};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    flex-direction: column;
    width: 100%;
    max-width: 300px;
    gap: ${props => props.theme.spacing.sm};
  }
`;

const SmoothScrollLink = styled.a`
  text-decoration: none;
  display: inline-block;
`;

const Hero: React.FC = () => {
  return (
    <HeroWrapper>
      <HeroContent>
        <HeroTitle>Empowering individuals, families & communities</HeroTitle>
        <HeroSubtitle>Creating paths to self-sustainability</HeroSubtitle>
        <ButtonContainer>
          <Button
            variant="accent"
            size="large"
            as={Link}
            to="/donate"
          >
            Donate Now
          </Button>
          <SmoothScrollLink href="#about">
            <Button
              variant="outline"
              size="large"
            >
              Learn More
            </Button>
          </SmoothScrollLink>
        </ButtonContainer>
      </HeroContent>
    </HeroWrapper>
  );
};

export default Hero; 